import { DatePicker, Form, Input, Select } from "antd";
import React, { useContext } from "react";
import SpecialtySelect from "@Components/user/SpecialtySelect";
import { IDispatchSetStateAction } from "@Components/shared/types";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";
import { useHasFeature } from "@Components/shared/queries";

interface AboutYouProps {
    current: number;
    setCurrent: IDispatchSetStateAction<number>;
}

const { Option } = Select;

const RegistrationPractice = ({ current, setCurrent }: AboutYouProps) => {
    const { ui: uiState } = useContext(MainContext);
    const isDesktop = uiState.mode === ViewMode.desktop;
    const isCurrent = current === 1;
    const { data: hasGraduationYearField } = useHasFeature("graduation-year-field");

    return (
        <div className="about-you-form" style={isCurrent ? null : { display: "none " }}>
            <div className="about-you-disclaimer">
                If you are not a medical professional, please skip ahead to the{" "}
                <span
                    tabIndex={0}
                    className="disclaimer-link"
                    onClick={() => {
                        setCurrent(current + 1);
                    }}
                >
                    Security
                </span>{" "}
                section.
            </div>
            <Form.Item
                label="Medical Specialty"
                name="specialty"
                className={isDesktop ? "black-label" : ""}
                rules={[
                    {
                        required: false,
                        message: "Please tell us your medical specialty",
                    },
                ]}
            >
                <SpecialtySelect />
            </Form.Item>
            <Form.Item
                label="Medical School"
                name="medicalSchool"
                className={isDesktop ? "black-label" : ""}
                rules={[
                    {
                        required: false,
                        message: "Please tell us your medical school",
                    },
                ]}
            >
                <Input placeholder="Please tell us your medical school" />
            </Form.Item>
            <Form.Item
                label="Organisation"
                name="organisation"
                className={isDesktop ? "black-label" : ""}
                rules={[
                    {
                        required: false,
                        message: "Please tell us your organisation",
                    },
                ]}
            >
                <Input placeholder="Please tell us your organisation" />
            </Form.Item>
            <Form.Item
                label="Years of Training"
                name="yearsTraining"
                className={isDesktop ? "black-label" : ""}
                rules={[
                    {
                        required: false,
                        message: "Please tell us your years of training",
                    },
                ]}
            >
                <Select placeholder="Select your years of training">
                    <Option value={1}>1</Option>
                    <Option value={2}>2</Option>
                    <Option value={3}>3</Option>
                    <Option value={4}>4</Option>
                    <Option value={5}>5</Option>
                    <Option value={6}>6</Option>
                    <Option value={7}>7</Option>
                    <Option value={8}>8</Option>
                    <Option value={9}>9</Option>
                    <Option value={10}>10+</Option>
                </Select>
            </Form.Item>
            {hasGraduationYearField ? (
                <Form.Item
                    label="Residency Graduation Year"
                    name="expectedGraduationYear"
                    className={isDesktop ? "black-label" : ""}
                    rules={[
                        {
                            required: true,
                            message: "Please tell us your residency graduation year",
                        },
                    ]}
                    tooltip="If you have already graduated, please provide a date in the past"
                >
                    <DatePicker picker="year" allowClear />
                </Form.Item>
            ) : null}
        </div>
    );
};

export default RegistrationPractice;
